// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import axios from "axios";
import Print from 'vue-print-nb'
Vue.prototype.$axios = axios;
Vue.use(Print) 
import navbars from '@/components/navbars';
import navbars1 from '@/components/navbars1';
import headers from '@/components/headers';
import headers1 from '@/components/headers1';
Vue.component('navbars', navbars)
Vue.component('navbars1', navbars1)
Vue.component('headers', headers)
Vue.component('headers1', headers1)

import 'swiper/dist/css/swiper.css'
import HappyScroll from 'vue-happy-scroll'
import 'vue-happy-scroll/docs/happy-scroll.css'
import 'element-ui/lib/theme-chalk/index.css';
import 'wowjs/css/libs/animate.css'
import './mixin'
import VideoPlayer from 'vue-video-player'
import '@/assets/css/css.css';
import '@/assets/css/reset.css';

import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
import 'vue-directive-image-previewer/dist/assets/style.css'
Vue.use(VueDirectiveImagePreviewer) 

import * as echarts from "echarts"
Vue.prototype.$echarts = echarts
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);
import * as dayjs from "dayjs";
Vue.prototype.$dayjs = dayjs;

import htmlToPdf from '@/utils/htmlToPdf'
Vue.use(htmlToPdf)

import print from '@/utils/print'
Vue.use(print)
//im 
// import TIM from 'tim-js-sdk/tim-js-friendship.js';
// import TIMUploadPlugin from 'tim-upload-plugin';
// import TIMProfanityFilterPlugin from 'tim-profanity-filter-plugin';
// let options = {
// 	SDKAppID: 1400649746 // 接入时需要将0替换为您的即时通信 IM 应用的 SDKAppID
// };
// // 创建 SDK 实例，`TIM.create()`方法对于同一个 `SDKAppID` 只会返回同一份实例
// let tim = TIM.create(options); // SDK 实例通常用 tim 表示
// // c27297d6641c68f9181f66ccb1bebff0f8666e64edd70eede58457279ff91195

// // 设置 SDK 日志输出级别，详细分级请参见 setLogLevel  https://web.sdk.qcloud.com/im/doc/zh-cn/SDK.html#setLogLevel 接口的说明</a>
// tim.setLogLevel(0); // 普通级别，日志量较多，接入时建议使用
// // tim.setLogLevel(1); // release 级别，SDK 输出关键信息，生产环境时建议使用


// 注册腾讯云即时通信 IM 上传插件
// tim.registerPlugin({
// 	'tim-upload-plugin': TIMUploadPlugin
// });


// 注册腾讯云即时通信 IM 本地审核插件
// tim.registerPlugin({
// 	'tim-profanity-filter-plugin': TIMProfanityFilterPlugin
// });

// Vue.prototype.TIM = TIM
// Vue.prototype.tim = tim
// Vue.prototype.isid=()=>{
//   Vue.prototype.isid = () => {
//     if (!Vue.prototype.$store.state.userInfo.id) {
//       throw ('未登录！')
//     }
//   }
// }
// Vue.prototype.shijian1 = function getYMDHMS(timestamp) {
// 	let time = new Date(timestamp)
// 	let year = time.getFullYear()
// 	const month = (time.getMonth() + 1).toString().padStart(2, '0')
// 	const date = (time.getDate()).toString().padStart(2, '0')
// 	const hours = (time.getHours()).toString().padStart(2, '0')
// 	const minute = (time.getMinutes()).toString().padStart(2, '0')
// 	const second = (time.getSeconds()).toString().padStart(2, '0')

// 	return month + '-' + date + ' ' + hours + ':' + minute + ':' + second
// }

store.dispatch("loadLocal");

// 路由守卫
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    store.commit("SET_HEADERSTITLE", to.meta.title);
    document.title = '军工人才网-企业端';
  }

  let token = store.state.token;
  if (token) {
    // tim.removeAllListeners(TIM.EVENT.MESSAGE_RECEIVED)
    console.log('to.path :>> ', to.path);
    // if(  to.path!='/user_user_chatchat')
    // Vue.prototype.tim.removeAllListeners(TIM.EVENT.MESSAGE_RECEIVED)
    next();
  } else {
    if (to.path === "/user_login" || to.path === "/user_xieyi") {
      next();
    } else {
      next("/user_login");
    }
  }
});

require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)

import VueI18n from "vue-i18n";
Vue.use(VueI18n);

import ch from './assets/languages/ch'
import en from './assets/languages/en'
const i18n = new VueI18n({
  locale: !localStorage.getItem("lang")
    ? "ch"
    : localStorage.getItem("lang"),
  messages: {
    'ch': ch,  // 本地资源文件，配2个语言，中文&英文，src下根据个人情况放置
    'en': en
  },
  silentTranslationWarn: true
});

// import waicTabs from '@/components/tabs'
// Vue.component('waic-tabs', waicTabs)

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper)
Vue.use(HappyScroll)
Vue.prototype.i18n = i18n;
/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js